<template>
   <div style="width:100%;height: 100px;align-items: center;display: flex;position: absolute;justify-content: center;">
      <div style="position: absolute;margin: auto;">
         <div class="my-ripple">
            <div></div>
            <div></div>
         </div>
      </div>
   </div>
</template>

<script>
   export default {
      name: 'loader',
      props: {
         msg: String
      }
   }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   .my-ripple {
      display: inline-block;
      position: relative;
      width: 64px;
      height: 64px;
   }

   .my-ripple div {
      position: absolute;
      border: 4px solid #8bc;
      opacity: 1;
      border-radius: 50%;
      animation: my-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
   }

   .my-ripple div:nth-child(2) {
      animation-delay: -0.5s;
   }

   @keyframes my-ripple {
      0% {
         top: 28px;
         left: 28px;
         width: 0;
         height: 0;
         opacity: 1;
      }
      100% {
         top: -1px;
         left: -1px;
         width: 58px;
         height: 58px;
         opacity: 0;
      }
   }
</style>